/* AV BMX -- the GALAXY TWIN (panel wf_2e7a75eb, replaces the rejected separate marble).
 *
 * The owner's rule: ONE globe design -- the homepage hero globe. On the homepage the ride runs
 * on the LIVE hero canvas (av-galaxy.js __avGalaxyRide API). Everywhere else THIS module boots
 * a visually identical twin into the overlay: same shell/volume/halo distributions, same colors,
 * same fbm nebula, same fov/camera formula -- already formed and slowly rotating (world-clock
 * phase, so repeat rides land on different longitudes) as the overlay fades in. Then the SAME
 * ride table as av-galaxy.js: latitude scan -> lime flare at contact -> present through the kA
 * ease -> dolly THROUGH the halo/volume to camDist 0.62 -> DOM ember at view-w<=0.50 -> dip.
 *
 * The ride-table block below is duplicated in av-galaxy.js (search: MUST MATCH galaxy ride table).
 *
 * Orchestrator contract unchanged: window.AVBMX.gl = {prewarm, ride, ok, pingPx, kill, reset};
 * prewarm on a DETACHED full-size canvas (pre-pays the fbm compile + backing store), TTL 8s;
 * 280ms watchdog in av-bmx.liquid falls back to the SVG globe; Lite pre-trips __avBmxGL. */
(function () {
  if (window.__avBmxGL) return; window.__avBmxGL = 1;
  if (!window.AVBMX) return;

  var COARSE = (window.AV_PHONE === true) ||
    (window.matchMedia && matchMedia('(hover:none),(pointer:coarse)').matches);
  var N = COARSE ? 12000 : 24000;                    /* the galaxy's own counts */
  var DPR = Math.min(window.devicePixelRatio || 1, 1.25) * 0.8;
  var FOV0 = 48 * Math.PI / 180;
  var ACC = [0.247, 0.827, 0.961];                   /* the hero globe accent */

  function bez(x1, y1, x2, y2) {
    return function (t) {
      if (t <= 0) return 0; if (t >= 1) return 1;
      var u = t;
      for (var i = 0; i < 5; i++) {
        var x = 3 * u * (1 - u) * (1 - u) * x1 + 3 * u * u * (1 - u) * x2 + u * u * u - t;
        var dx = 3 * (1 - u) * (1 - u) * x1 + 6 * u * (1 - u) * (x2 - x1) + 3 * u * u * (1 - x2);
        if (Math.abs(dx) < 1e-6) break;
        u -= x / dx; u = Math.max(0, Math.min(1, u));
      }
      return 3 * u * (1 - u) * (1 - u) * y1 + 3 * u * u * (1 - u) * y2 + u * u * u;
    };
  }
  var easeDive = bez(0.55, 0, 0.30, 1);
  function mP(fy, asp, n, f) { var t = 1 / Math.tan(fy / 2); return [t / asp, 0, 0, 0, 0, t, 0, 0, 0, 0, (f + n) / (n - f), -1, 0, 0, (2 * f * n) / (n - f), 0]; }
  function mT(x, y, z) { return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, y, z, 1]; }
  function mRX(a) { var c = Math.cos(a), s = Math.sin(a); return [1, 0, 0, 0, 0, c, s, 0, 0, -s, c, 0, 0, 0, 0, 1]; }
  function mRY(a) { var c = Math.cos(a), s = Math.sin(a); return [c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1]; }
  function mMul(a, b) { var o = new Float32Array(16); for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) { var s = 0; for (var k = 0; k < 4; k++) s += a[k * 4 + r] * b[c * 4 + k]; o[c * 4 + r] = s; } return o; }
  function rotYP(v, ya, pi) { var c = Math.cos(pi), s = Math.sin(pi); var y = c * v[1] - s * v[2], z = s * v[1] + c * v[2]; var cy = Math.cos(ya), sy = Math.sin(ya); return [cy * v[0] + sy * z, y, -sy * v[0] + cy * z]; }
  function invRotYP(v, ya, pi) { var cy = Math.cos(ya), sy = Math.sin(ya); var x = cy * v[0] - sy * v[2], z = sy * v[0] + cy * v[2]; var c = Math.cos(pi), s = Math.sin(pi); return [x, c * v[1] + s * z, -s * v[1] + c * z]; }

  /* ---------- shaders: the galaxy recipe minus windows/trail/ctr/scroll, plus the ride terms ---------- */
  var BGFS = ['precision highp float;',
    'uniform vec2 uRes;uniform float uTime;uniform float uNebDim;',
    'float hash(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float vn(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.0-2.0*f);float a=hash(i),b=hash(i+vec2(1.,0.)),c=hash(i+vec2(0.,1.)),d=hash(i+vec2(1.,1.));return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}',
    'float fbm(vec2 p){float s=0.,a=.5;for(int i=0;i<5;i++){s+=a*vn(p);p=p*2.03+vec2(7.1,3.7);a*=.5;}return s;}',
    'void main(){vec2 uv=gl_FragCoord.xy/uRes;float asp=uRes.x/uRes.y;vec2 p=(uv-0.5);p.x*=asp;',
    'float t=uTime*0.025;float w=fbm(p*1.5+vec2(0.,t));vec2 wr=vec2(fbm(p*1.3+w+t),fbm(p*1.3-w-t*0.5))-0.5;',
    'float b1=fbm(p*vec2(1.1,1.7)+wr*1.5+vec2(t*0.4,-t));float au=pow(smoothstep(0.25,0.92,b1),1.5);',
    'vec3 cDeep=vec3(0.02,0.035,0.09),cCy=vec3(0.05,0.40,0.62),cVi=vec3(0.34,0.18,0.66);',
    'vec3 col=mix(cDeep,cCy,au);col=mix(col,cVi,smoothstep(0.5,1.1,au)*0.7);col*=0.92;col+=cDeep*0.81;',
    'float cg=exp(-length((uv-0.5)*vec2(asp,1.0))*2.1);col+=(cCy*0.55+cVi*0.45)*cg*0.7;',
    'float vig=smoothstep(1.4,0.32,length((uv-0.5)*vec2(asp,1.)*1.12));col*=0.32+0.68*vig;',
    'col+=(hash(uv*uRes+uTime)-0.5)*0.015;col*=(1.0-uNebDim);gl_FragColor=vec4(max(col,0.0),1.0);}'].join('');
  var PTVS = ['attribute vec3 aPos;attribute vec3 aCol;attribute float aSize;',
    'uniform mat4 uMVP;uniform float uPx;uniform float uTime;',
    'uniform vec3 uFlareDir;uniform float uFlareC;uniform float uScanL;uniform float uScanI;',
    'uniform float uGatherT;uniform float uLineT;uniform vec2 uNodeNdc;',
    'uniform vec4 uCards[4];uniform vec2 uVp;',
    'varying vec3 vCol;varying float vT;varying float vW;varying float vF;varying float vLand;',
    'void main(){',
    /* MUST MATCH av-galaxy.js: THE COLLAPSE (v4) -- per-particle hashes derived from aPos */
    'float h4=fract(sin(dot(aPos,vec3(12.9898,78.233,37.719)))*43758.5453);',
    'float h5=fract(sin(dot(aPos,vec3(26.651,20.63,44.921)))*43758.5453);',
    'float h6=fract(sin(dot(aPos,vec3(53.731,11.187,4.703)))*43758.5453);',
    'vec4 cp=uMVP*vec4(aPos,1.0);float w=max(cp.w,0.15);',
    'float fr=length(aPos);float cd=dot(aPos/max(fr,1e-4),uFlareDir);',
    'float f=smoothstep(0.998488,1.0,cd)*smoothstep(0.12,0.05,abs(fr-1.0));',
    'float sc=uScanI*exp(-abs(asin(clamp(aPos.y/max(fr,1e-4),-1.0,1.0))-uScanL)*9.0)*smoothstep(0.12,0.04,abs(fr-1.0));',
    'vF=f*clamp(uFlareC,0.0,1.0);',
    'vec2 ndc=cp.xy/cp.w;',
    /* THE COLLAPSE core (v5) -- identical text to av-galaxy.js: every particle flies to a slot on
       the perimeter of its NEAREST category-card rect (px space, rounded corners) */
    'float ang=acos(clamp(cd,-1.0,1.0))*0.318309886;',
    'float shl=smoothstep(0.30,0.10,abs(fr-1.0));',
    'float ord=mix(h4*0.34,clamp(0.38+0.56*(1.0-ang)+(h5-0.5)*0.10,0.0,0.995),shl);',
    'float clp=clamp((uGatherT-ord*0.70)/0.30,0.0,1.0);float ce=clp*clp*(3.0-2.0*clp);',
    'vec2 cpx=vec2((ndc.x*0.5+0.5)*uVp.x,(0.5-ndc.y*0.5)*uVp.y);',
    'vec4 sel=uCards[0];float bd=1.0e9;',
    'for(int ci=0;ci<4;ci++){vec4 cc=uCards[ci];if(cc.z<1.0)continue;vec2 cn=cc.xy+cc.zw*0.5;float dd=distance(cpx,cn);if(dd<bd){bd=dd;sel=cc;}}',
    'vec2 hf=sel.zw*0.5;vec2 ctr=sel.xy+hf;float rr=min(18.0,min(sel.z,sel.w)*0.5);',
    'float per=2.0*(sel.z+sel.w);float sp=fract(h4*3.7+h5*0.31)*per;vec2 lp;',
    'if(sp<sel.z)lp=vec2(-hf.x+sp,-hf.y);',
    'else if(sp<sel.z+sel.w)lp=vec2(hf.x,-hf.y+(sp-sel.z));',
    'else if(sp<2.0*sel.z+sel.w)lp=vec2(hf.x-(sp-sel.z-sel.w),hf.y);',
    'else lp=vec2(-hf.x,hf.y-(sp-2.0*sel.z-sel.w));',
    'vec2 qc=abs(lp)-(hf-vec2(rr));',
    'if(qc.x>0.0&&qc.y>0.0)lp=sign(lp)*((hf-vec2(rr))+normalize(qc)*rr);',
    'vec2 tpx=ctr+lp+normalize(lp+vec2(1.0e-4))*((h6-0.5)*1.6);',
    'vec2 tgt=vec2(tpx.x/uVp.x*2.0-1.0,1.0-tpx.y/uVp.y*2.0);',
    'vec2 dl=tgt-ndc;float dLen=length(dl);vec2 pp=vec2(-dl.y,dl.x)/max(dLen,1e-4);',
    'ndc=mix(ndc,tgt,ce)+pp*(h5-0.5)*1.85*dLen*ce*(1.0-ce);vLand=ce;',
    'float wl=mix(cp.w,1.0,ce);',
    'cp.xy=ndc*wl;cp.z=mix(cp.z,0.0,ce);cp.w=wl;vW=wl;gl_Position=cp;',
    'float tr=4.0*ce*(1.0-ce);',
    /* the SNAP: each particle flashes as it clicks into the contour -- MUST MATCH av-galaxy.js */
    'float snp=smoothstep(0.86,1.0,ce)*(1.0-smoothstep(0.97,1.0,ce));',
    'float psb=aSize*uPx/w*(1.0+sc*0.6+f*uFlareC*0.8);',
    'float psl=min(aSize*uPx*(0.22+0.10*uLineT),8.0);',
    'gl_PointSize=clamp(mix(psb,psl,ce)*(1.0-0.25*tr)*(1.0+snp*1.35),1.0,42.0);',
    'vCol=aCol;vT=0.55+0.45*sin(uTime*1.8+aPos.x*9.0+aPos.z*6.0);',
    'vCol=mix(vCol,vec3(0.784,1.0,0.102)*(1.15+0.4*uFlareC),vF);vCol*=(1.0+sc*1.1);vT+=f*uFlareC*0.5;',
    'vCol=mix(vCol,vec3(0.62,0.94,1.0)*(1.18+0.40*uLineT),ce);vT=mix(vT,1.0+0.35*uLineT,ce);',
    'vCol+=vec3(0.42,0.86,1.0)*snp*0.9;vT+=snp*0.55;}'].join('');
  var PTFS = ['precision mediump float;varying vec3 vCol;varying float vT;varying float vW;varying float vF;varying float vLand;uniform float uNearF;',
    'void main(){vec2 c=gl_PointCoord-0.5;float r=length(c);float a=smoothstep(0.5,0.12,r);a*=a;',
    'a*=mix(mix(1.0,smoothstep(0.30,0.85,vW),uNearF),1.0,vF);',
    /* docked alpha cap: phones get a higher cap or the frames vanish mid-formation -- MUST MATCH av-galaxy.js */
    'float dk=smoothstep(0.62,0.98,vLand);a*=mix(1.0,' + (COARSE ? '0.24' : '0.10') + ',dk);',
    'gl_FragColor=vec4(vCol*vT*1.2,a);}'].join('');

  var E = null;   /* engine {cv,gl,bgP,bgU,ptP,ptU,quad,posB,colB,sizB,pos,siz,W,H,proj,uPx,ff,ttl,raf} */
  var ZCARDS = new Float32Array(16);   /* ambient/prewarm: zero rects -> collapse block is a no-op at ce=0 */
  function cardsF32(rects) {           /* MUST MATCH av-galaxy.js */
    var a = new Float32Array(16);
    for (var i = 0; i < 4; i++) {
      var r = (rects && rects[i]) || [0, 0, 0, 0];
      a[i * 4] = r[0]; a[i * 4 + 1] = r[1]; a[i * 4 + 2] = r[2]; a[i * 4 + 3] = r[3];
    }
    return a;
  }

  function build() {
    try {
      var W = window.innerWidth, H = window.innerHeight;
      var cv = document.createElement('canvas');
      cv.width = Math.max(2, Math.round(W * DPR));
      cv.height = Math.max(2, Math.round(H * DPR));
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;opacity:0;transition:opacity .2s ease;z-index:2';
      var gl = cv.getContext('webgl', { alpha: false, antialias: false, premultipliedAlpha: false, powerPreference: 'low-power' }) ||
               cv.getContext('experimental-webgl');
      if (!gl) return null;
      function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(o)); return null; } return o; }
      function prog(v, f) { var vv = sh(gl.VERTEX_SHADER, v), ff2 = sh(gl.FRAGMENT_SHADER, f); if (!vv || !ff2) return null; var p = gl.createProgram(); gl.attachShader(p, vv); gl.attachShader(p, ff2); gl.linkProgram(p); return gl.getProgramParameter(p, gl.LINK_STATUS) ? p : null; }
      var bgP = prog('attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}', BGFS);
      var ptP = prog(PTVS, PTFS);
      if (!bgP || !ptP) return null;
      var bgU = { res: gl.getUniformLocation(bgP, 'uRes'), time: gl.getUniformLocation(bgP, 'uTime'), nebDim: gl.getUniformLocation(bgP, 'uNebDim') };
      var ptU = { mvp: gl.getUniformLocation(ptP, 'uMVP'), px: gl.getUniformLocation(ptP, 'uPx'), time: gl.getUniformLocation(ptP, 'uTime'),
        flareDir: gl.getUniformLocation(ptP, 'uFlareDir'), flareC: gl.getUniformLocation(ptP, 'uFlareC'),
        scanL: gl.getUniformLocation(ptP, 'uScanL'), scanI: gl.getUniformLocation(ptP, 'uScanI'), nearF: gl.getUniformLocation(ptP, 'uNearF'),
        gatherT: gl.getUniformLocation(ptP, 'uGatherT'), lineT: gl.getUniformLocation(ptP, 'uLineT'), nodeNdc: gl.getUniformLocation(ptP, 'uNodeNdc'),
        cards: gl.getUniformLocation(ptP, 'uCards[0]'), vp: gl.getUniformLocation(ptP, 'uVp') };

      /* the hero globe's exact distribution: 50% fibonacci shell, 32% volume, 18% halo */
      var pos = new Float32Array(N * 3), col = new Float32Array(N * 3), siz = new Float32Array(N);
      var aW = [Math.min(1, ACC[0] + 0.5), Math.min(1, ACC[1] + 0.5), Math.min(1, ACC[2] + 0.5)];
      var GA = Math.PI * (3 - Math.sqrt(5)), shellN = Math.floor(N * 0.5), volN = Math.floor(N * 0.32);
      for (var i = 0; i < N; i++) {
        var x, y, z, kind = i < shellN ? 0 : (i < shellN + volN ? 1 : 2);
        if (kind === 0) { var tt = (i + 0.5) / shellN, yy = 1 - 2 * tt, rad = Math.sqrt(Math.max(0, 1 - yy * yy)), th = GA * i; x = Math.cos(th) * rad; y = yy; z = Math.sin(th) * rad; var jr = 1 + (Math.random() - 0.5) * 0.05; x *= jr; y *= jr; z *= jr; }
        else if (kind === 1) { var u = Math.random() * 2 - 1, ph = Math.random() * 6.2832, sr = Math.sqrt(1 - u * u), rr = Math.pow(Math.random(), 0.55); x = Math.cos(ph) * sr * rr; y = u * rr; z = Math.sin(ph) * sr * rr; }
        else { var u2 = Math.random() * 2 - 1, ph2 = Math.random() * 6.2832, sr2 = Math.sqrt(1 - u2 * u2), rr2 = 1.05 + Math.pow(Math.random(), 1.6) * 1.45; x = Math.cos(ph2) * sr2 * rr2; y = u2 * rr2; z = Math.sin(ph2) * sr2 * rr2; }
        pos[i * 3] = x; pos[i * 3 + 1] = y; pos[i * 3 + 2] = z;
        var m2 = Math.min(1, Math.max(0, 0.5 + 0.5 * y + (Math.random() - 0.5) * 0.5));
        var cr = ACC[0] + (aW[0] - ACC[0]) * m2, cgc = ACC[1] + (aW[1] - ACC[1]) * m2, cb = ACC[2] + (aW[2] - ACC[2]) * m2;
        var br = kind === 0 ? 1.0 : (kind === 1 ? 0.7 : 0.5);
        if (Math.random() < 0.03) { cr = 1.0; cgc = 0.93; cb = 0.85; br *= 1.15; }
        col[i * 3] = cr * br; col[i * 3 + 1] = cgc * br; col[i * 3 + 2] = cb * br;
        siz[i] = kind === 0 ? (Math.random() < 0.045 ? 0.04 : 0.016) : (kind === 1 ? 0.013 : 0.010);
      }
      function buf(a) { var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, a, gl.STATIC_DRAW); return b; }
      var quad = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, quad); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var eng = { cv: cv, gl: gl, bgP: bgP, bgU: bgU, ptP: ptP, ptU: ptU, quad: quad,
        posB: buf(pos), colB: buf(col), sizB: buf(siz), pos: pos, siz: siz,
        aP: gl.getAttribLocation(ptP, 'aPos'), aC: gl.getAttribLocation(ptP, 'aCol'), aS: gl.getAttribLocation(ptP, 'aSize'),
        bgL: gl.getAttribLocation(bgP, 'p'),
        W: W, H: H, ff: false, ttl: 0, raf: 0 };
      eng.proj = mP(FOV0, cv.width / cv.height, 0.1, 100);
      eng.uPx = cv.height * 0.5 / Math.tan(FOV0 * 0.5);
      gl.viewport(0, 0, cv.width, cv.height);
      gl.disable(gl.DEPTH_TEST);
      drawFrame(eng, null, 0);                        /* prewarm frame: both programs hot */
      return eng;
    } catch (e) { return null; }
  }

  function drawFrame(eng, R, tm) {
    var gl = eng.gl;
    gl.disable(gl.BLEND); gl.useProgram(eng.bgP);
    gl.bindBuffer(gl.ARRAY_BUFFER, eng.quad); gl.enableVertexAttribArray(eng.bgL); gl.vertexAttribPointer(eng.bgL, 2, gl.FLOAT, false, 0, 0);
    gl.uniform2f(eng.bgU.res, eng.cv.width, eng.cv.height); gl.uniform1f(eng.bgU.time, tm); gl.uniform1f(eng.bgU.nebDim, R ? R.nd : 0);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    var model = mMul(mRY(eng.yaw || 0), mRX(eng.pitch || 0));
    var view = mT(-(eng.panX || 0), -(eng.panY || 0), -(R ? R.cam : eng.C0 || 2.96));
    var mvp = mMul(eng.proj, mMul(view, model));
    gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE); gl.useProgram(eng.ptP);
    gl.bindBuffer(gl.ARRAY_BUFFER, eng.posB); gl.enableVertexAttribArray(eng.aP); gl.vertexAttribPointer(eng.aP, 3, gl.FLOAT, false, 0, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, eng.colB); gl.enableVertexAttribArray(eng.aC); gl.vertexAttribPointer(eng.aC, 3, gl.FLOAT, false, 0, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, eng.sizB); gl.enableVertexAttribArray(eng.aS); gl.vertexAttribPointer(eng.aS, 1, gl.FLOAT, false, 0, 0);
    gl.uniformMatrix4fv(eng.ptU.mvp, false, mvp); gl.uniform1f(eng.ptU.px, eng.uPx); gl.uniform1f(eng.ptU.time, tm);
    if (R) {
      gl.uniform3f(eng.ptU.flareDir, R.m[0], R.m[1], R.m[2]); gl.uniform1f(eng.ptU.flareC, R.fc); gl.uniform1f(eng.ptU.scanL, R.scanL); gl.uniform1f(eng.ptU.scanI, R.scanI); gl.uniform1f(eng.ptU.nearF, R.nf);
      gl.uniform1f(eng.ptU.gatherT, R.gg || 0); gl.uniform1f(eng.ptU.lineT, R.ll || 0); gl.uniform2f(eng.ptU.nodeNdc, R.nn ? R.nn[0] : 0, R.nn ? R.nn[1] : 0);
      gl.uniform4fv(eng.ptU.cards, R.cards || ZCARDS); gl.uniform2f(eng.ptU.vp, window.innerWidth, window.innerHeight);
    }
    else {
      gl.uniform3f(eng.ptU.flareDir, 0, 0, 1); gl.uniform1f(eng.ptU.flareC, 0); gl.uniform1f(eng.ptU.scanL, Math.PI / 2); gl.uniform1f(eng.ptU.scanI, 0); gl.uniform1f(eng.ptU.nearF, 0);
      gl.uniform1f(eng.ptU.gatherT, 0); gl.uniform1f(eng.ptU.lineT, 0); gl.uniform2f(eng.ptU.nodeNdc, 0, 0);
      gl.uniform4fv(eng.ptU.cards, ZCARDS); gl.uniform2f(eng.ptU.vp, 1, 1);
    }
    gl.drawArrays(gl.POINTS, 0, N);
  }

  function destroy(eng) {
    if (!eng) return;
    try { cancelAnimationFrame(eng.raf); } catch (e) { }
    try { if (eng.cv.parentNode) eng.cv.parentNode.removeChild(eng.cv); } catch (e) { }
    try { var x = eng.gl.getExtension('WEBGL_lose_context'); if (x) x.loseContext(); } catch (e) { }
  }

  /* ================= MUST MATCH -- galaxy ride table (av-galaxy.js) ================= */
  function ride(S) {
    if (!E) E = build();
    if (!E) return false;
    clearTimeout(E.ttl);
    var eng = E, gl = eng.gl;
    var W = window.innerWidth, H = window.innerHeight;
    if (Math.abs(W - eng.W) > 2 || Math.abs(H - eng.H) > 2) {
      eng.W = W; eng.H = H;
      eng.cv.width = Math.max(2, Math.round(W * DPR)); eng.cv.height = Math.max(2, Math.round(H * DPR));
      gl.viewport(0, 0, eng.cv.width, eng.cv.height);
      eng.proj = mP(FOV0, eng.cv.width / eng.cv.height, 0.1, 100);
      eng.uPx = eng.cv.height * 0.5 / Math.tan(FOV0 * 0.5);
    }
    S.overlay.appendChild(eng.cv);

    var short = !!S.short;
    var C0 = 2.96 * Math.max(1.0, 0.9 * eng.cv.height / eng.cv.width);
    eng.C0 = C0;
    /* world-clock spin phase: repeat rides land on different longitudes; settles over 240ms */
    var yaw0 = (Date.now() / 1000 * 0.072) % (Math.PI * 2);
    eng.yaw = yaw0; eng.pitch = -0.06; eng.panX = 0; eng.panY = 0;

    /* selection: anchor ray -> shell hit -> back-rotate -> nearest drawn shell particle */
    var anchor = COARSE ? [0, 0.24] : [0, 0.20];
    var tanYv = Math.tan(FOV0 / 2), aspv = eng.cv.width / eng.cv.height;
    var dirv = [anchor[0] * tanYv * aspv, anchor[1] * tanYv, -1];
    var dl = Math.hypot(dirv[0], dirv[1], dirv[2]);
    dirv = [dirv[0] / dl, dirv[1] / dl, dirv[2] / dl];
    var b = -dirv[2] * C0, disc = Math.max(0, b * b - (C0 * C0 - 1)), sq = Math.sqrt(disc);
    var tNear = b - sq, tFar = b + sq;
    var vNear = [dirv[0] * tNear, dirv[1] * tNear, dirv[2] * tNear];
    var tPick = (-vNear[2] >= 0.45) ? tNear : tFar;
    var hit = [dirv[0] * tPick, dirv[1] * tPick, dirv[2] * tPick + C0];
    var hl = Math.hypot(hit[0], hit[1], hit[2]) || 1;
    var wdir = [hit[0] / hl, hit[1] / hl, hit[2] / hl];
    var m = invRotYP(wdir, eng.yaw, eng.pitch);
    var bi = -1, bd = 1e9, bgi = -1, bgd = 1e9, i;
    for (i = 0; i < N; i++) {
      var s3 = eng.siz[i]; if (s3 <= 0.015) continue;
      var x = eng.pos[i * 3], y = eng.pos[i * 3 + 1], z2 = eng.pos[i * 3 + 2];
      var L = Math.hypot(x, y, z2);
      if (L < 0.95 || L > 1.05) continue;
      var dv = Math.acos(Math.max(-1, Math.min(1, (x * m[0] + y * m[1] + z2 * m[2]) / L)));
      if (dv < bd) { bd = dv; bi = i; }
      if (s3 > 0.03 && dv < bgd) { bgd = dv; bgi = i; }
    }
    var pick = (bgi >= 0 && bgd <= 0.09 && bgd <= bd + 0.06) ? bgi : bi;
    var pPos = pick >= 0 ? [eng.pos[pick * 3], eng.pos[pick * 3 + 1], eng.pos[pick * 3 + 2]] : m.slice();
    var pl = Math.hypot(pPos[0], pPos[1], pPos[2]) || 1;
    var pdir = [pPos[0] / pl, pPos[1] / pl, pPos[2] / pl];
    /* pose solve */
    var A2 = pdir[1], B2 = pdir[2], RR = Math.sqrt(A2 * A2 + B2 * B2) || 1e-6;
    var base = Math.atan2(B2, A2);
    var ac = Math.acos(Math.max(-1, Math.min(1, wdir[1] / RR)));
    function angDiff(a2, b3) { var d2 = (a2 - b3) % (Math.PI * 2); if (d2 > Math.PI) d2 -= Math.PI * 2; if (d2 < -Math.PI) d2 += Math.PI * 2; return d2; }
    var P1 = ac - base, P2 = -ac - base;
    var Pstar = Math.abs(angDiff(P1, eng.pitch)) <= Math.abs(angDiff(P2, eng.pitch)) ? P1 : P2;
    var cP = Math.cos(Pstar), sP = Math.sin(Pstar);
    var u = [pdir[0], cP * pdir[1] - sP * pdir[2], sP * pdir[1] + cP * pdir[2]];
    var Ystar = eng.yaw + angDiff(Math.atan2(wdir[0], wdir[2]) - Math.atan2(u[0], u[2]), 0);
    var latStar = Math.asin(Math.max(-1, Math.min(1, pdir[1])));

    var rd = eng.rd = { t0: performance.now(), short: short, C0: C0, anchor: anchor,
      Ystar: Ystar, Pstar: Pstar, m: pdir, pPos: pPos, latStar: latStar,
      tc: 280 + (Math.PI / 2 - latStar) / Math.PI * 440,
      frames: 0, emberT: 0, dipped: 0, hudF: 0, panFrozen: false, lastCam: C0, lastFov: FOV0, last: 0,
      cards: cardsF32(S.cardRects) };
    eng.ff = false;

    S.pingPxFn = function () {
      if (!eng.rd) return 0;
      var q = rotYP(rd.pPos, eng.yaw, eng.pitch);
      return px(eng, q, rd.lastCam, rd.lastFov);
    };

    function px(e2, q, cam, fovN) {
      var wv = cam - q[2]; if (wv < 0.05) wv = 0.05;
      var tY = Math.tan(fovN / 2), tX = tY * (e2.cv.width / e2.cv.height);
      var nx = (q[0] - e2.panX) / (wv * tX), ny = (q[1] - e2.panY) / (wv * tY);
      return [(nx + 1) / 2 * window.innerWidth, (1 - ny) / 2 * window.innerHeight];
    }

    function frame() {
      eng.raf = requestAnimationFrame(frame);
      var now = performance.now(), t = now - rd.t0;
      var dtF = Math.min((rd.last ? now - rd.last : 16.7) / 1000, 0.1) * 60; rd.last = now;
      rd.frames++;
      if (!eng.ff) { eng.ff = true; eng.cv.style.opacity = '1'; }
      /* spin decays + retarget through the galaxy's kA filter */
      var kA = 1 - Math.pow(0.95, dtF);
      eng.yaw += 0.072 / 60 * dtF * Math.pow(1 - Math.min(t / 240, 1), 4);
      eng.yaw += (Ystar - eng.yaw) * kA;
      eng.pitch += (Pstar - eng.pitch) * kA;
      /* scan */
      var scanL = Math.PI / 2, scanI = 0;
      if (!short && t >= 280) {
        var te = t - 280, contact = rd.tc - 280;
        if (te <= contact) scanL = Math.PI / 2 - Math.PI * te / 440;
        else { var q2 = Math.min(1, (te - contact) / 90); scanL = rd.latStar - (4 * Math.PI / 180) * q2 * (2 - q2); }
        scanI = Math.min(1, te / 60);
        var fs = t - (rd.tc + 90);
        if (fs > 0) scanI *= Math.max(0, 1 - fs / 195);
      }
      /* THE COLLAPSE drive -- MUST MATCH av-galaxy.js: full drain 620-3320 (2700ms, 3x slower) +
         settle 3040-3320; short drain 260-560 + settle 470-560. gg/ll upload LINEAR -- all
         order/stagger/easing is per-particle in the shader. */
      var gg = short ? Math.max(0, Math.min(1, (t - 260) / 300))
                     : Math.max(0, Math.min(1, (t - 620) / 2700));
      var gE = gg * gg * (3 - 2 * gg);
      /* condense: phones ramp EARLY and slowly -- MUST MATCH av-galaxy.js */
      var ll = short ? Math.max(0, Math.min(1, (t - 470) / 90))
                     : Math.max(0, Math.min(1, (t - (COARSE ? 2600 : 3040)) / (COARSE ? 720 : 280)));
      /* flare */
      var fc = 0, ft = short ? 120 : rd.tc;
      if (t >= ft) {
        var tf = t - ft;
        if (short) fc = 0.55 * Math.min(1, tf / 40);
        else if (tf < 60) fc = 1.6 * tf / 60;
        else fc = 0.35 + (1.6 - 0.35) * Math.exp(-(tf - 60) / 90);
        fc *= 1 + 0.08 * Math.sin(2 * Math.PI * 1.6 * now / 1000);
      }
      if (short && rd.emberT) fc *= Math.max(0, 1 - (t - rd.emberT) / 60);
      fc += 1.15 * gE * (1 - ll);   /* the node BURNS as the globe drains into it, then hands off to the blade */
      if (!short && !rd.hudF && t >= rd.tc + 80) { rd.hudF = 1; try { if (window.AVBMX && window.AVBMX.hudFound) window.AVBMX.hudFound(); } catch (e) { } }
      /* BOTH rides park OUTSIDE the shell at 1.30; on full rides the dolly breathes across the
         WHOLE formation -- MUST MATCH av-galaxy.js */
      var d0 = short ? 240 : 560, dd = short ? 320 : 1900;
      var dp = t <= d0 ? 0 : Math.min(1, (t - d0) / dd);
      var k = easeDive(dp);
      var cam = C0 + (1.30 - C0) * k;
      var fovN = FOV0 + (6 * Math.PI / 180) * dp * dp;
      eng.proj = mP(fovN, eng.cv.width / eng.cv.height, 0.1, 100);
      eng.uPx = eng.cv.height * 0.5 / Math.tan(fovN * 0.5);
      var nf = t <= d0 ? 0 : Math.min(1, (t - d0) / 150);
      var q = rotYP(rd.pPos, eng.yaw, eng.pitch);
      var wv = cam - q[2]; if (wv < 0.05) wv = 0.05;
      if (!rd.panFrozen && dp > 0) {
        var tY2 = Math.tan(fovN / 2);
        eng.panX = q[0] * k;
        eng.panY = (q[1] - anchor[1] * k * wv * tY2) * k;
      }
      if (!rd.emberT && (short ? (wv <= 0.50 || dp >= 0.60) : dp >= 0.92)) {
        rd.emberT = t; rd.panFrozen = true;
        var p2 = px(eng, q, cam, fovN);
        S.emberXY = [Math.round(p2[0]), Math.round(p2[1])];
        try { window.AVBMX.ember(p2[0], p2[1]); } catch (e) { }
      }
      var dipAt = short ? 565 : 3460;
      if (!rd.dipped && t >= dipAt) { rd.dipped = 1; try { window.AVBMX.dip(short ? 120 : 135); } catch (e) { } }
      rd.lastCam = cam; rd.lastFov = fovN;
      var ndB = 0.65 * k;   /* CUT-OPEN inhale -- MUST MATCH av-galaxy.js; phones keep the sky lit longer */
      var nds = short ? 300 : (COARSE ? 1400 : 900), ndd = short ? 240 : 1500;
      if (t > nds) ndB += (1 - ndB) * Math.min(1, (t - nds) / ndd);
      /* line target: DOM S.lineXY is AUTHORITATIVE once set (twin px space = innerHeight, see px()) */
      var tYn = Math.tan(fovN / 2), tXn = tYn * (eng.cv.width / eng.cv.height);
      var nnx = (q[0] - eng.panX) / (wv * tXn), nny = (q[1] - eng.panY) / (wv * tYn);
      if (S.lineXY) {
        nnx = S.lineXY[0] / window.innerWidth * 2 - 1;
        nny = 1 - 2 * S.lineXY[1] / window.innerHeight;
      }
      if (!rd.nn) rd.nn = [nnx, nny];
      else { rd.nn[0] += (nnx - rd.nn[0]) * 0.35; rd.nn[1] += (nny - rd.nn[1]) * 0.35; }
      drawFrame(eng, { cam: cam, fovN: fovN, scanL: scanL, scanI: scanI, fc: fc, nf: nf, nd: ndB, m: rd.m, gg: gg, ll: ll, nn: [rd.nn[0], rd.nn[1]], cards: rd.cards }, now / 1000);
    }
    eng.raf = requestAnimationFrame(frame);

    document.addEventListener('visibilitychange', function onVis() {
      if (document.hidden) { cancelAnimationFrame(eng.raf); document.removeEventListener('visibilitychange', onVis); }
    });
    return true;
  }
  /* ================= end MUST MATCH ================= */

  window.AVBMX.gl = {
    prewarm: function () {
      try {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && Shopify.designMode) return;
        try { if (sessionStorage.getItem('avBmxSlow') === '1') return; } catch (e) { }
        if (E) { clearTimeout(E.ttl); E.ttl = setTimeout(function () { destroy(E); E = null; }, 8000); return; }
        var go = function () {
          if (E) return;
          E = build();
          if (E) E.ttl = setTimeout(function () { destroy(E); E = null; }, 8000);
        };
        if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 400 }); else setTimeout(go, 1);
      } catch (e) { }
    },
    ride: ride,
    ok: function () { return !!(E && E.ff); },
    pingPx: function (S) { return S && S.pingPxFn ? S.pingPxFn() : 0; },
    kill: function () { destroy(E); E = null; },
    reset: function () {
      if (!E) return;
      try { cancelAnimationFrame(E.raf); } catch (e) { }
      try { if (E.cv.parentNode) E.cv.parentNode.removeChild(E.cv); } catch (e) { }
      E.cv.style.opacity = '0'; E.ff = false; E.rd = null;
      E.panX = 0; E.panY = 0; E.yaw = 0; E.pitch = -0.06;
      E.proj = mP(FOV0, E.cv.width / E.cv.height, 0.1, 100);
      E.uPx = E.cv.height * 0.5 / Math.tan(FOV0 * 0.5);
      clearTimeout(E.ttl);
      E.ttl = setTimeout(function () { destroy(E); E = null; }, 8000);
    }
  };
})();
